import type { ReactNode } from "react";
import { Layout } from "@circle-react/components/shared/CustomizeUI";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface SectionProps {
  children?: ReactNode;
  className?: string;
  id?: string;
}

export const Section = ({ className, children, id }: SectionProps) => (
  <Layout.Main className="!bg-primary">
    <div
      id={id}
      className={classNames("mx-auto max-w-6xl p-0 md:px-0 lg:py-8", className)}
    >
      {children}
    </div>
  </Layout.Main>
);
